import { render, staticRenderFns } from "./UpstreamAndDownstreamRisk.vue?vue&type=template&id=3bcc6403&scoped=true&"
import script from "./UpstreamAndDownstreamRisk.vue?vue&type=script&lang=js&"
export * from "./UpstreamAndDownstreamRisk.vue?vue&type=script&lang=js&"
import style0 from "./UpstreamAndDownstreamRisk.vue?vue&type=style&index=0&id=3bcc6403&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcc6403",
  null
  
)

export default component.exports